import { render, staticRenderFns } from "./CategoryMultiselectDropdown.vue?vue&type=template&id=ef886c74&scoped=true"
import script from "./CategoryMultiselectDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryMultiselectDropdown.vue?vue&type=script&lang=js"
import style0 from "./CategoryMultiselectDropdown.vue?vue&type=style&index=0&id=ef886c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef886c74",
  null
  
)

export default component.exports